"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importDefault(require("react"));
const menu_1 = __importDefault(require("../../menu"));
const Header2Nav = (props) => {
    const { logged, cp, navSections, segmentMenu, municipios, municipio, rehidrate } = props;
    const selector = logged ? "logged" : "default";
    return (react_1.default.createElement("div", { className: "header2-nav container" },
        react_1.default.createElement("div", { className: "menu" },
            react_1.default.createElement("div", { className: "section-menu", "data-cy": "Header links" },
                react_1.default.createElement(menu_1.default, { items: navSections[selector], layout: "default", location: "menu", rehidrate: rehidrate })),
            react_1.default.createElement("div", { className: "segment-menu", "data-cy": "Header secondary links" },
                react_1.default.createElement(menu_1.default, { items: segmentMenu[selector], layout: "default", location: "menu", rehidrate: rehidrate }))),
        react_1.default.createElement("div", { className: "options" },
            react_1.default.createElement(menu_1.default, { layout: "cp", location: "menu", cp: cp, municipios: municipios, rehidrate: rehidrate, municipio: municipio }))));
};
exports.default = Header2Nav;
//# sourceMappingURL=index.js.map